import { notification, message } from 'antd';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

const Dropzone = ({ app, children, style, onFileDrop, disabled, allowMultiple = true }) => {
  const dz = useRef(null);
  const [error, setError] = useState('');

  const handleDrop = async (event) => {
    event.preventDefault();

    if (disabled) {
      return;
    }

    setError(''); // Reset error message on each drop
    const items = event.dataTransfer.items;
    const files = [];

    // Recursively read all files in directories
    const traverseFileTree = (entry, path = '') => {
      return new Promise((resolve, reject) => {
        if (entry.isFile) {
          entry.file((file) => {
            if (file.size > app.maxFileSize * 1024) {
              message.error(<span><strong>{file.name}</strong> exceeds maximum allowed size.</span>);
              resolve(); // Don't reject, just skip the file
            } else {
              file.relativePath = path + file.name;
              files.push(file);
              resolve();
            }
          }, reject);
        } else if (entry.isDirectory && allowMultiple) {
          const dirReader = entry.createReader();
          const readEntriesRecursive = () => {
            dirReader.readEntries((entries) => {
              if (entries.length === 0) {
                resolve();
                return;
              }

              const promises = entries.map((subEntry) =>
                traverseFileTree(subEntry, path + entry.name + '/')
              );

              Promise.all(promises).then(readEntriesRecursive).catch(reject);
            }, reject);
          };

          readEntriesRecursive();
        } else {
          resolve();
        }
      });
    };

    const promises = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry();
      if (entry) {
        promises.push(traverseFileTree(entry));
      }
    }

    try {
      await Promise.all(promises);

      // Check conditions for multiple files or folders
      if (!allowMultiple && (files.length > 1 || items[0].webkitGetAsEntry().isDirectory)) {
        setError('Only a single file is allowed.');
        onFileDrop([]);
      } else {
        onFileDrop(files);
      }
    } catch (error) {
      console.error("Error while processing files: ", error);
      setError('An error occurred while processing the files.');
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();

    event.dataTransfer.dropEffect = disabled ? 'none' : 'copy';
  };

  return (
    <div onDrop={handleDrop} onDragOver={handleDragOver} style={{ height: '100%', width: '100%', ...style }}>
      {children}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { app } = state;
  return { app };
};

export default connect(mapStateToProps)(Dropzone);
